// import React from "react";
// import { BackToTop } from "@patternfly/react-core";

// const BackToTopButton = () => (
//   <BackToTop
//     scrollableSelector=".pf-v6-c-compass__content"
//   />
// );

// export default BackToTopButton;

import React, { useEffect, useState } from "react";
import { Button, ButtonVariant } from "@patternfly/react-core";
import { ArrowUpIcon } from "@patternfly/react-icons";

import "./BackToTopButton.css";

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <Button
      size="sm"
      variant={ButtonVariant.primary}
      icon={<ArrowUpIcon />}
      className="back-to-top-button"
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        })
      }
      aria-label="Wróć na górę"
    />
  );
};

export default BackToTopButton;